@if (filteredNomenclatures | async; as Nomenclatures) { @if (!readonly()) {
<div class="form-field-group-tooltip">
    <mat-form-field [ngStyle]="formFieldStyles()">
        <mat-label>{{ label() }}</mat-label>
        <input
            #input
            type="text"
            [name]="label()"
            [attr.data-tfa]="label() + '_' + dataTfaIdentifier()"
            matInput
            [formControl]="_internalForm"
            [matAutocomplete]="auto"
            [errorStateMatcher]="errorStateMatcher"
            (focus)="onTouched()"
        />
        @if (showResetButton() && input.value && _internalForm?.enabled) {
        <button
            mat-icon-button
            matSuffix
            (click)="reset()"
            [attr.data-tfa]="'empty-input-button_' + label()"
            aria-label="Supprimer la valeur saisie"
        >
            <mat-icon [attr.data-tfa]="'empty-input-icon_' + label()">close</mat-icon>
        </button>
        }
        <mat-error *appFormMatErrors="_internalForm!; customErrors: {}"></mat-error>
    </mat-form-field>
    @if (nomenclatureIsEmpty$ | async) {
    <button
        mat-icon-button
        class="aucune-nomenclature-button"
        [attr.data-tfa]="'icone-info-nomenclature-vide_' + label()"
        (click)="tooltip.toggle()"
        #tooltip="matTooltip"
        matTooltip="La nomenclature est vide"
    >
        <mat-icon color="accent" data-tfa="icon_info_tooltip">info</mat-icon>
    </button>
    }
</div>
<mat-autocomplete
    #auto="matAutocomplete"
    data-tfa="autoComplete"
    role="combobox"
    aria-expanded="false"
    [attr.aria-label]="'Sélection de ' + label()"
    [displayWith]="getFullValue(Nomenclatures)"
    [panelWidth]="500"
>
    @for (n of Nomenclatures; track n) {
    <mat-option [value]="n.code" [attr.data-tfa]="'nomenclatures_option-' + n.code" (onSelectionChange)="onSelect($event)">
        <span> {{ getFullValueFn()(n) }} </span>
    </mat-option>
    } @if (Nomenclatures.length === 0 && input.value) {
    <mat-option disabled data-tfa="nomenclatures_option-INVALIDE" disabled>Votre saisie est invalide</mat-option>
    }
</mat-autocomplete>
} @else {
{{ getLibelle(Nomenclatures)(_internalForm!.value) }}
} }
